"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuantitySpinButton = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_icon_1 = require("@hopin-team/ui-icon");

var react_1 = tslib_1.__importStar(require("react"));

var context_1 = require("../context");

var spin_button_1 = require("../styled/spin-button");

var spin_button_root_1 = require("../styled/spin-button-root");

var QuantitySpinButton = function QuantitySpinButton(_a) {
  var className = _a.className,
      __UIScope = _a.__UIScope,
      testID = _a["data-testid"],
      onIncrement = _a.onIncrement,
      _b = _a.incrementLabel,
      incrementLabel = _b === void 0 ? 'increment' : _b,
      onDecrement = _a.onDecrement,
      _c = _a.decrementLabel,
      decrementLabel = _c === void 0 ? 'decrement' : _c;
  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'QuantityField__SpinButton',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;

  var _d = (0, react_1.useContext)(context_1.QuantityFieldContext),
      sizeOption = _d.sizeOption,
      isInverse = _d.isInverse;

  return react_1.default.createElement(spin_button_root_1.SpinButtonRoot, {
    className: rootClasses,
    "data-testid": testID,
    flexDirection: "column",
    sizeOption: sizeOption
  }, react_1.default.createElement(spin_button_1.SpinButton, {
    onClick: onIncrement,
    sizeOption: sizeOption,
    isInverse: isInverse,
    type: "button"
  }, react_1.default.createElement(ui_icon_1.Icon, {
    name: "arrow-up",
    scale: 1,
    title: incrementLabel,
    color: "grey-400"
  })), react_1.default.createElement(spin_button_1.SpinButton, {
    onClick: onDecrement,
    sizeOption: sizeOption,
    isInverse: isInverse,
    type: "button"
  }, react_1.default.createElement(ui_icon_1.Icon, {
    name: "arrow-down",
    scale: 1,
    title: decrementLabel,
    color: "grey-400"
  })));
};

var QuantitySpinButtonWithSpace = (0, ui_helper_with_space_1.withSpace)(QuantitySpinButton);
exports.QuantitySpinButton = QuantitySpinButtonWithSpace;